import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback } from 'react';
import { downloadUrl as download } from '../../../../../utils';
import { FormattedMessage } from 'react-intl-next';
import { ActionName } from '../../../../../constants';
import { messages } from '../../../../../messages';
import Action from '../action';
import { useFlexibleUiAnalyticsContext, useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import useInvokeClientAction from '../../../../../state/hooks/use-invoke-client-action';
import DownloadIcon from '@atlaskit/icon/glyph/download';
var DownloadAction = function DownloadAction(_ref) {
  var _context$actions;
  var onClickCallback = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var context = useFlexibleUiContext();
  var analytics = useFlexibleUiAnalyticsContext();
  var invoke = useInvokeClientAction({
    analytics: analytics
  });
  var data = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[ActionName.DownloadAction];
  var onClick = useCallback(function () {
    if (data !== null && data !== void 0 && data.downloadUrl) {
      invoke({
        actionType: ActionName.DownloadAction,
        actionFn: function () {
          var _actionFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", download(data === null || data === void 0 ? void 0 : data.downloadUrl));
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function actionFn() {
            return _actionFn.apply(this, arguments);
          }
          return actionFn;
        }(),
        // These values have already been set in analytics context.
        // We only pass these here for ufo experience.
        display: analytics === null || analytics === void 0 ? void 0 : analytics.display,
        extensionKey: analytics === null || analytics === void 0 ? void 0 : analytics.extensionKey
      });
      if (onClickCallback) {
        onClickCallback();
      }
    }
  }, [analytics, data === null || data === void 0 ? void 0 : data.downloadUrl, invoke, onClickCallback]);
  var isStackItem = props.as === 'stack-item';
  var label = isStackItem ? messages.download_file : messages.download;
  var tooltipMessage = isStackItem ? messages.download_description : messages.download;
  return data ? /*#__PURE__*/React.createElement(Action, _extends({
    content: /*#__PURE__*/React.createElement(FormattedMessage, label)
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
    ,
    icon: /*#__PURE__*/React.createElement(DownloadIcon, {
      label: "Download"
    }),
    onClick: onClick,
    testId: "smart-action-download-action",
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, tooltipMessage)
  }, data, props)) : null;
};
export default DownloadAction;